<template>
  <div id="app">
		<router-link to="/Login"></router-link>
    <router-view/>
  </div>
</template>


<script>
export default {
	name: 'App',
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'margin:0;')
  },
}
</script>
<style>
div,span,img,body{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
</style>